import { ValidationResult as a } from "./index4.js";
import { Messages as r } from "./index5.js";
class o {
  validate(e, s) {
    return s && s.length !== 0 ? a.success() : a.failure(r.getInvalidPasswordMessage(e));
  }
}
export {
  o as PasswordValidator
};
//# sourceMappingURL=index3.js.map
